<template>
    <Navbar/>
    <BlogBody/>
    <Footer/>
  </template>
  
  <script>
  import { defineComponent } from "vue";
  import Navbar from "@/components/NavbarBody.vue";
  import BlogBody from "@/components/BlogBody.vue";
  import Footer from "@/components/FooterBody.vue"; 
  
  export default defineComponent({
    name: "BlogView",
    components: {
      Navbar,
      BlogBody,
      Footer
    },
  });
  </script>
  